module.exports = __webpack_public_path__ + "img/default.26d07d0a.jpg";